export default __webpack_public_path__ + "static/media/newplaceholder.e624a2f5.png";